export const antDividerBorderTopColor = "rgba(0,0,0,0.45)";